"use client";

import { menu_define } from '@/core/constants/menu-define'
import MenuItem from './item'
import { useTranslation } from 'react-i18next';
import SidebarSettings from '../settings';

export default function SideBarMenu() {
  const { t } = useTranslation();
  const menuItems = menu_define(t);

  // Séparer : mainItems (tout sauf Logout et Version), logoutItem (avant-dernier), versionItem (dernier)
  const mainItems = menuItems.slice(0, -2);
  const logoutItem = menuItems[menuItems.length - 2];
  const versionItem = menuItems[menuItems.length - 1];

  return (
    <>
      {mainItems &&
        mainItems.length > 0 &&
        mainItems.map((item, index) => (
          <MenuItem key={index} item={item} />
        ))}
      
      {/* Bottom section: icônes langue/thème + logout + version */}
      <div className="sidebar-bottom">
        <SidebarSettings />
        {logoutItem && <MenuItem item={logoutItem} />}
        {versionItem && <MenuItem item={versionItem} />}
      </div>
    </>
  )
}
